// extracted by mini-css-extract-plugin
module.exports = {"description":"_fb3d6882"};